import AntdCard from 'antd/lib/card'
import styles from './SavedTasksCard.module.less'
import { RightOutlined } from '@ant-design/icons'
import { TaskMode } from 'Types/Tasks.types.ts'

export type CardTagPropsType = {
    title: string
    type: 'primary' | TaskMode
}

export type CardPropsType = {
    title: string
    tags?: CardTagPropsType[]
    savedTasks?: number
    onClick: () => void
}

const SavedTasksCard = (props: CardPropsType) => {
    return (
        <div className={styles['card-container']} data-testid="saved-tasks-card-wrapper">
            <AntdCard
                className={styles['card']}
                classNames={{
                    body: styles['card-body'],
                }}
                onClick={() => props.onClick()}
            >
                <div className={styles['card-content']}>
                    <div className={styles['left-section']}>
                        <div className={styles['card-title']}>{props.title}</div>
                        {props.tags?.length && (
                            <div className={styles['tags-container']}>
                                {props.tags.map((tag: CardTagPropsType) => (
                                    <div
                                        className={styles['tag'] + ' ' + styles[tag.type]}
                                        key={tag.title}
                                    >
                                        {tag.title}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className={styles['right-section']}>
                        <div className={styles['saved-tasks-box']}>
                            <div className={styles['saved-label']}>Saved tasks</div>
                            <div className={styles['task-count']}>{props.savedTasks}</div>
                        </div>
                        <RightOutlined className={styles['chevron']} />
                    </div>
                </div>
            </AntdCard>
        </div>
    )
}

export default SavedTasksCard
